<template>
	<div style="background-color: #fff;">
		<el-row :gutter="24">
			<el-col :span="6">
				<!-- 传递子组件需要的数组数据（通常是item.data） -->
				<score_item_total 
					:data="jingjinxing.data" 
					:title="$t('driver.经济性得分')" 
					:score="jingjinxing.Score || 0" 
					:popoverTitle="$t('driver.经济性')" 
					:popoverContent="$t('driver.经济性提示')"
				/>
			</el-col>
			<el-col :span="6">
				<score_item_total 
					:data="shushixing.data" 
					:title="$t('driver.舒适性得分')" 
					:score="shushixing.Score || 0" 
					:popoverTitle="$t('driver.舒适性')"
					:popoverContent="$t('driver.舒适性提示')"
				/>
			</el-col>
			<el-col :span="6">
				<score_item_total 
					:data="anquanxing.data" 
					:title="$t('driver.安全性得分')" 
					:score="anquanxing.Score || 0" 
					:popoverTitle="$t('driver.安全性')"
					:popoverContent="$t('driver.安全性提示')"
				/>
			</el-col>
			<el-col :span="6">
				<score_item_total 
					:data="huchexing.data" 
					:title="$t('driver.护车性得分')" 
					:score="huchexing.Score || 0" 
					:popoverTitle="$t('driver.护车性')"
					:popoverContent="$t('driver.护车性提示')"
				/>
			</el-col>
		</el-row>
	</div>
</template>
<script>
	import score_item_total from './score_item_total.vue'
	export default {
		props: {
			drivingScore: Array
		},
		components: {
			score_item_total
		},
		data() {
			return {
				jingjinxing: [],  // 初始化为null，避免undefined报错
				shushixing: [],
				anquanxing: [],
				huchexing: [],
			}
		},
		// 关键：监听drivingScore变化，数据加载后再赋值
		watch: {
			drivingScore: {
				handler(newVal) {
					if (Array.isArray(newVal) && newVal.length >= 4) {
						// 确保数组有足够元素再赋值
						this.jingjinxing = newVal[0];
						this.shushixing = newVal[1];
						this.anquanxing = newVal[2];
						this.huchexing = newVal[3];
					}
				},
				immediate: true,  // 初始化时立即执行
				deep: true
			}
		}
	}
</script>
    